import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/theusual.webp';
import screenshot_target from '../../../images/letterfunnel/joachimdelooij.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Joachim de Looij"
      firstname="Joachim"
      companyname="The Usual"
      competition="CitizenM en The Social Hub"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/joachimdelooij.js